import { noAuthBaseApi } from '@services/api';
import apiRoutes from '@constants/apiRoutes';
import { INVITATION_STATUS_CODE } from '@constants/constants';
import { ApiResponse } from './types/common';

export type InvitationStatusCode =
  (typeof INVITATION_STATUS_CODE)[keyof typeof INVITATION_STATUS_CODE];

export interface InvitationValidityDetails {
  statusCode: InvitationStatusCode;
}

const linkValidityApi = noAuthBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    /* Check Invitation Validity */
    checkInvitationValidity: builder.query<
      ApiResponse<InvitationValidityDetails>,
      { invitationId: string }
    >({
      query: ({ invitationId }) => apiRoutes.checkInvitationValidity(invitationId),
    }),
  }),
});

const { useLazyCheckInvitationValidityQuery } = linkValidityApi;

export { useLazyCheckInvitationValidityQuery };
